import { useState, useEffect } from "react";
import { useHistory } from "react-router";

import queryString from "query-string";
import { Redirect } from "react-router-dom";

import { makeRequest } from "@/util";
import { ConfirmSwitchTeams } from "./ConfirmSwitchTeams";
import AcceptInvitePage from "./AcceptInvitePage";
import { PendingInviteResponse } from "./types";

export function PendingInvitePage(props) {
  if (!props.isSignedIn) {
    // prevent the next URL from sending user to sign out page
    const next = props.location.pathname.includes("signout")
      ? null
      : props.location.pathname + props.location.search;
    return <Redirect to={`/login?${queryString.stringify({ next })}`} />;
  } else {
    return <PendingInvitePageHelper />;
  }
}

function PendingInvitePageHelper() {
  const history = useHistory();

  const [inviteID, setInviteID] = useState<string | null>(null);
  const [fromEmail, setFromEmail] = useState<string | null>(null);
  const [transferConfirmed, setTransferConfirmed] = useState(false);

  useEffect(() => {
    makeRequest("get_pending_invite", {})
      .then((response) => {
        const data = response.data as PendingInviteResponse;
        if (!data.id) {
          history.push("/events");
        }

        setInviteID(data.id || null);
        setFromEmail(data.from_email || null);
      })
      .catch((error) => {
        console.error(error);
      });
  }, [history]);

  if (inviteID) {
    if (!transferConfirmed) {
      return (
        <ConfirmSwitchTeams
          inviteID={inviteID}
          fromEmail={fromEmail}
          onConfirm={() => setTransferConfirmed(true)}
        />
      );
    } else {
      return (
        <AcceptInvitePage
          transferConfirmed={true}
          pendingInviteID={inviteID}
          isSignedIn={true}
        />
      );
    }
  } else {
    return null;
  }
}
